import { BasePresenter } from "core/presenter";
import UserConstraint from "core/constraint/user.constraint";
import validate from "util/validate";

class PasswordFieldsPresenter extends BasePresenter {
  initialState() {
    return {
      visible: false,
      password: "",
      confirmPassword: "",
      mode: ""
    };
  }

  doValidateField(value, field) {
    const constraint = UserConstraint.password;
    const validation = validate(
      {
        password: this.viewModel.password,
        confirmPassword: this.viewModel.confirmPassword
      },
      constraint,
      { fullMessages: false }
    );

    return validation;
  }
}

export default PasswordFieldsPresenter;



// WEBPACK FOOTER //
// ./src/components/app/registration/user/form/general-info/password-fields/password-fields.presenter.js